import React from 'react'
import { Trans } from '@lingui/macro'
import {
  MatchedSearchableItem,
  SearchableItem
} from './SelectEntitiesForm.types'
import { MatchedEntity } from './MatchedEntity'
import { SelectEntitiesFormViewSearch } from 'front-end/src/components/common/selectEntitiesForm/SelectEntitiesFormViewSearch'
import { Box } from 'front-end/src/components'
import { InfiniteScrollWrapper } from '../../utils/InfiniteScrollWrapper'

type SelectResourcesModalViewProps = {
  selectedIds: Set<SearchableItem['id']>
  resetQuery: () => void
  changeQuery: (val: string) => void
  query: string
  items: MatchedSearchableItem[]
  selectItem: (id: SearchableItem['id']) => void
}

export const SelectEntitiesFormView: React.FC<SelectResourcesModalViewProps> =
  ({ selectedIds, resetQuery, selectItem, changeQuery, query, items }) => {
    return (
      <>
        <SelectEntitiesFormViewSearch
          defaultQuery={query}
          resetQuery={resetQuery}
          changeQuery={changeQuery}
        />

        <Box className="List">
          {items.length === 0 && (
            <p className="List__Row__noResults">
              <Trans>No results</Trans>
            </p>
          )}
          <InfiniteScrollWrapper items={items}>
            {(slicedItems) =>
              slicedItems.map((searchableItem) => (
                <MatchedEntity
                  handleSelect={selectItem}
                  isSelected={selectedIds.has(searchableItem.item.id)}
                  matchedItem={searchableItem}
                  key={`${searchableItem.item.type}-${searchableItem.item.id}`}
                />
              ))
            }
          </InfiniteScrollWrapper>
        </Box>
      </>
    )
  }
